import m from "./../../../dist/es2015/themes/Responsive.js";
export const am5themes_Responsive = m;